import { userStore, dappStore, positionStore } from '.';

/* Getters: userStore */
export const useUserAddress = () => userStore((state) => state.userAddress);
export const useProvider = () => userStore((state) => state.provider);
export const useSigner = () => userStore((state) => state.signer);
export const useBalanceEth = () => userStore((state) => state.balanceArch);
export const useBalanceEthIn18Dec = () => userStore((state) => state.balanceArchIn18Dec);
export const useBalanceLvusd = () => userStore((state) => state.balanceArch);
export const useBalanceLvusdIn18Dec = () => userStore((state) => state.balanceArchIn18Dec);
export const useBalanceArch = () => userStore((state) => state.balanceArch);
export const useBalanceArchIn18Dec = () => userStore((state) => state.balanceArchIn18Dec);
export const useBalanceOusd = () => userStore((state) => state.balanceOusd);
export const useBalanceOusdIn18Dec = () => userStore((state) => state.balanceOusdIn18Dec);
export const useBalanceUsdc = () => userStore((state) => state.balanceUsdc);
export const useBalanceUsdt = () => userStore((state) => state.balanceUsdt);
export const useBalanceDai = () => userStore((state) => state.balanceDai);
export const useNetwork = () => userStore((state) => state.network);
export const useNetworkID = () => userStore((state) => state.networkID);
export const usePositions = () => userStore((state) => state.positions);

/* Getters: dappStore */
export const useIsAppInitialized = () => dappStore((state) => state.isAppInitialized);
export const useIsProcessingModalOpen = () => dappStore((state) => state.isProcessingModalOpen);
export const useIsViewNft = () => dappStore((state) => state.isViewNft);
export const getShowIsRouteAndFeesModal = () => dappStore((state) => state.showRouteAndFeesModal);
export const useIsWrongNetwork = () => dappStore((state) => state.isWrongNetwork);
export const useIsClosePositionModal = () => dappStore((state) => state.isClosePositionModal);
export const useIsClosingPositionModal = () => dappStore((state) => state.isClosingPositionModal);
export const useIsCloseConfirmationModal = () => dappStore((state) => state.isCloseConfirmationModal);
export const useActivePositionId = () => dappStore((state) => state.activePositionId);
export const useLeverageInterval = () => dappStore((state) => state.leverageInterval);
export const useArchLvusdRatioInterval = () => dappStore((state) => state.archLvusdRatioInterval);
export const useArchPriceInterval = () => dappStore((state) => state.archPriceInterval);
export const useArchPrice = () => dappStore((state) => state.archPrice);
export const useLatestTx = () => dappStore((state) => state.latestTx);
export const useCurrentError = () => dappStore((state) => state.currentError);
export const useBodyScroll = () => dappStore((state) => state.bodyScroll);
export const useContracts = () => dappStore((state) => state.contracts);
export const useAddresses = () => dappStore((state) => state.addresses);
export const useLevMultiplier = () => dappStore((state) => state.leverageMultiplier);
export const useArchMultiplier = () => dappStore((state) => state.archMultiplier);
export const useNumOfCycles = () => dappStore((state) => state.numOfCycles);
export const useOriginationFee = () => dappStore((state) => state.originationFee);
export const usePerformanceFee = () => dappStore((state) => state.performanceFee);
export const useLvUSDToArchRatio = () => dappStore((state) => state.lvUSDToArchRatio);
export const useLvUSDToArchRatioIn18Dec = () => dappStore((state) => state.lvUSDToArchRatioIn18Dec);
export const useLeverageAvailable = () => dappStore((state) => state.leverageAvailable);
export const useLeverageAvailableIn18Dec = () => dappStore((state) => state.leverageAvailableIn18Dec);
export const useOusdApy = () => dappStore((state) => state.ousdAPY);
export const useLeveragedOusdApy = () => dappStore((state) => state.leveragedOusdApy);
export const useFinalOusdApy = () => dappStore((state) => state.finalOusdApy);
export const useLtAPY = () => dappStore((state) => state.ltAPY);
export const useLpAPY = () => dappStore((state) => state.lpAPY);
export const useTvl = () => dappStore((state) => state.tvl);
export const getShowLegalDisclaimerModal = () => dappStore((state) => state.showLegalDisclaimerModal);
export const useOusdCollateralMinimum = () => dappStore((state) => state.ousdCollateralMinimum);
export const useShowUnavailableClosingPositionModal = () =>
  dappStore((state) => state.showUnavailableClosingPositionModal);
export const useGetPositionLifetimeInDays = () => dappStore((state) => state.positionLifetimeInDays);
export const useBalancesLoaded = () => dappStore((state) => state.balancesLoaded);
export const useStableCoinApprovalsLoaded = () => dappStore((state) => state.stableCoinApprovalsLoaded);
export const useArchApprovalLoaded = () => dappStore((state) => state.archApprovalLoaded);
export const useContractsLoaded = () => dappStore((state) => state.contractsLoaded);
export const useMinimumDepositIncreased = () => dappStore((state) => state.minimumDepositIncreased);
export const useActivePosition = () => dappStore((state) => state.activePosition);
export const useModalProps = () => dappStore((state) => state.modalProps);

/* Getters: positionStore */
export const useIsArchApproved = () => positionStore((state) => state.isArchApproved);
export const useIsOusdApproved = () => positionStore((state) => state.isOusdApproved);
export const useApprovedArch = () => positionStore((state) => state.approvedArch);
export const useApprovedArchIn18Dec = () => positionStore((state) => state.approvedArchIn18Dec);
export const useApprovedOusd = () => positionStore((state) => state.approvedOusd);
export const useApprovedOusdIn18Dec = () => positionStore((state) => state.approvedOusdIn18Dec);
export const useOpenPositionPrincipal = () => positionStore((state) => state.openPositionPrincipal);
export const useOpenPositionPrincipalIn18Dec = () => positionStore((state) => state.openPositionPrincipalIn18Dec);
export const useOpenPositionDebt = () => positionStore((state) => state.openPositionDebt);
export const useOpenPositionDebtIn18Dec = () => positionStore((state) => state.openPositionDebtIn18Dec);
export const useOpenPositionArchNeeded = () => positionStore((state) => state.openPositionArchNeeded);
export const useOpenPositionArchNeededIn18Dec = () => positionStore((state) => state.openPositionArchNeededIn18Dec);
export const useOpenPositionArchToBurn = () => positionStore((state) => state.openPositionArchToBurn);
export const useOpenPositionArchToBurnIn18Dec = () => positionStore((state) => state.openPositionArchToBurnIn18Dec);
export const useIsUsdtApproved = () => positionStore((state) => state.isUsdtApproved);
export const useIsUsdcApproved = () => positionStore((state) => state.isUsdcApproved);
export const useIsDaiApproved = () => positionStore((state) => state.isDaiApproved);
export const useApprovedUsdc = () => positionStore((state) => state.approvedUsdc);
export const useApprovedUsdt = () => positionStore((state) => state.approvedUsdt);
export const useApprovedDai = () => positionStore((state) => state.approvedDai);
